var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0H703L99 1024H-1V0Z",
    fill: "#EDF3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222 1024H99L702 0H825L222 1024Z",
    fill: "#D1F1F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340 1024H217L820 0H943L340 1024Z",
    fill: "#C3EDF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M463 1024H340L943 0H1066L463 1024Z",
    fill: "#B3E9F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M585 1024H462L1065 0H1188L585 1024Z",
    fill: "#A8EBFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M707 1024H584L1187 0H1310L707 1024Z",
    fill: "#9EE9F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.5 1024L706 1024L1309.5 0H1439.5L1439.5 1024Z",
    fill: "#87E5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.0bb873d39952c309444a15282ef0b572.svg";
export { ForwardRef as ReactComponent };